import styled from 'styled-components';

export const ButtonWrapper = styled.button<{ isAboveStickyCTA: boolean }>`
  position: fixed;
  bottom: 24px;
  right: 24px;
  cursor: pointer;
  z-index: 1000;
  background-color: white;
  color: white;
  border: 1px solid black;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  padding: 0.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.4s ease;

  &:focus-visible {
    outline: none;
  }

  @media (hover: hover) {
    &:hover {
      background: #e0e0e0;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      svg path {
        fill: #555555;
      }
    }
  }

  @media (max-width: 768px) {
    bottom: ${(props) => (props.isAboveStickyCTA ? '128px' : '24px')};
  }
`;

export const Prompt = styled.div<{ isAboveStickyCTA: boolean }>`
  position: fixed;
  bottom: 68px;
  right: 68px;
  z-index: 1000;
  background: #F0F0F0;
  color: #000000;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border-bottom-left-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  font-family: Lato;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  padding: 8px 12px;
  width: 210px;
  word-wrap: break-word;
  transition: all 0.4s ease;

  p {
    font-size: 14px;
    margin: 0;
  }

  @media (max-width: 768px) {
    bottom: ${(props) => (props.isAboveStickyCTA ? '172px' : '68px')};
  }
`;
